"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _releaseManage = _interopRequireDefault(require("@/views/applet/setting/companyapp/modules/releaseManage.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
var _default = exports.default = {
  name: 'MiniProgramReleaseManage',
  components: {
    ReleaseManage: _releaseManage.default
  },
  methods: {
    open: function open(row) {
      this.$refs.releaseManage.open(row);
    }
  }
};